export const TAGLINE = 'Search for people, tags, folders, and Looms';
export const SEARCHBAR_MAC_TOOLTIP = 'Search: ⌘ + K';
export const SEARCHBAR_WIN_TOOLTIP = 'Search: Ctrl + K';
